import { Controller } from "@hotwired/stimulus"

import 'tom-select'
import TomSelect from "tom-select"

// Connects to data-controller="tom-select"
export default class extends Controller {
  connect() {
    if (this.element.getAttribute("multiple") == "multiple") {
      var settings = {
        maxOptions: null,
        plugins: {
          "checkbox_options": {
            "checkedClassNames": ["ts-checked"],
            "uncheckedClassNames": ["ts-unchecked"]
          }
        },
        hidePlaceholder: this.element.dataset.hidePlaceholder == "true" ? true : false,
        render: {
          option: function (data, escape) {
            return `<div><i class="fal fa-${escape(data.icon)}"></i>&nbsp;` + escape(data.text) + '</div>';
          },
          item: function (data, escape) {
            return `<span class="bg-warning badge badge-sm text-dark me-1"><i class="fal fa-${escape(data.icon)}"></i></span>`;
          }
        }
      }
    } else {
      var settings = {
        maxOptions: null
      }
    }

    new TomSelect(this.element, settings);
  }
}
